export const columns: TableColumn[] = [
    {
      Header: "tableCommon.sl_no",
      accessor: "slno",
    },
    {
        Header: 'scheduleOperator.tableColumns.production_schedule',
        accessor: 'production_schedule_name',
    },
    {
        Header: 'scheduleOperator.tableColumns.product_name',
        accessor: 'product_name',
    },
    {
      Header: "scheduleProduction.tableColumns.area_name",
      accessor: "area_name",
    },
    {
      Header: "Activity Type",
      accessor: "activity_type",
    },
    {
      Header: "scheduleOperator.tableColumns.assignee",
      accessor: "assignee",
    },
    {
      Header: "Finger Dabbed User",
      accessor: "finger_dabbed_user",
    },
    
    // {
    //   Header: "generatePlateQr.tableColumns.location",
    //   accessor: "location_name",
    // },
    {
      Header: "QR Generated Date",
      accessor: "qr_generated_date",
    },
    // {
    //   Header: "scheduleOperator.tableColumns.status",
    //   accessor: "status",
    // },
    {
      Header: "generatePlateQr.tableColumns.plateSerialNo",
      accessor: "plate_serial_no",
    },
  ];


  interface TableColumn {
    Header: string;
    accessor: string;
  }